export const HOME = {
  searchInput: "homepage-search-input",
  submitBtn: "submit-query-button",
  exampleChip: (i) => `example-chip-${i}`,
  themeToggle: "theme-toggle",
  adminLink: "admin-link",
  logo: "site-logo",
};

export const CHAT = {
  input: "chat-input",
  sendBtn: "chat-send-btn",
  newChatBtn: "new-chat-btn",
  historyItem: (i) => `history-item-${i}`,
  mobileHistoryBtn: "mobile-history-btn",
  recommendationCard: "recommendation-card",
  verdictBanner: "verdict-banner",
  confidenceBar: "confidence-bar",
  bestFor: "best-for-list",
  avoidIf: "avoid-if-list",
  affiliateBtn: (cta) => `affiliate-btn-${cta}`,
  valueScore: "value-score",
  backHome: "back-home-btn",
  voteHelpful: "vote-helpful-btn",
  voteUnhelpful: "vote-unhelpful-btn",
  shareBtn: "share-recommendation-btn",
  purchaseYes: "purchase-yes-btn",
  purchaseNo: "purchase-no-btn",
};

export const SHARE = {
  page: "share-page",
  copyBtn: "share-copy-btn",
  ctaBtn: "share-cta-btn",
};

export const ADMIN = {
  emailInput: "admin-email-input",
  passwordInput: "admin-password-input",
  loginBtn: "admin-login-btn",
  logoutBtn: "admin-logout-btn",
  statCard: (n) => `stat-card-${n}`,
};

export const QA = {
  page: "qa-page",
  search: "qa-search-input",
  ratingFilter: "qa-rating-filter",
  flagFilter: "qa-flag-filter",
  row: (id) => `qa-row-${id}`,
  rowCheckbox: (id) => `qa-row-checkbox-${id}`,
  selectAll: "qa-select-all",
  bulkBar: "qa-bulk-bar",
  bulkBtn: (kind) => `qa-bulk-${kind}-btn`,
  auditBanner: "qa-audit-banner",
  detailBtn: (id) => `qa-detail-${id}`,
  ratingBtn: (rating) => `qa-rating-${rating}-btn`,
  feedbackBtn: (kind) => `qa-feedback-${kind}-btn`,
  noteInput: "qa-note-input",
  noteSubmit: "qa-note-submit",
  noteItem: (i) => `qa-note-${i}`,
  drawerClose: "qa-drawer-close",
};

export const QUEUE = {
  page: "queue-page",
  card: (kind) => `queue-card-${kind}`,
  item: (kind, i) => `queue-item-${kind}-${i}`,
};

export const AFFILIATE = {
  page: "affiliate-page",
  statCard: (n) => `affiliate-stat-${n}`,
};
